import { duration, spacing, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { trackSize, trackSizeHover } from "../config";
import { trackStyles } from "./trackStyles";
import isPropValid from "@emotion/is-prop-valid";
export const TrackX = styled.div.withConfig({
    shouldForwardProp: isPropValid,
}) `
  left: 0;
  bottom: calc(-1 * (${trackSizeHover} + ${spacing.base.xs}));
  width: 100%;
  transition: width ${duration.animation.fast}ms ease;
  height: ${trackSize};

  ${trackStyles};

  &.hover,
  &.active,
  &:hover,
  &:active {
    height: ${trackSizeHover};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHJhY2tYLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU2Nyb2xsYmFyL3N0eWxlZC9UcmFja1gudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUNMLFFBQVEsRUFDUixPQUFPLEdBQ1IsTUFBTSxnREFBZ0QsQ0FBQztBQUN4RCxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLEVBQUUsU0FBUyxFQUFFLGNBQWMsRUFBRSxNQUFNLFdBQVcsQ0FBQztBQUN0RCxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBQzVDLE9BQU8sV0FBVyxNQUFNLHdCQUF3QixDQUFDO0FBRWpELE1BQU0sQ0FBQyxNQUFNLE1BQU0sR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFDLFVBQVUsQ0FBQztJQUMxQyxpQkFBaUIsRUFBRSxXQUFXO0NBQy9CLENBQUMsQ0FBQTs7dUJBRXFCLGNBQWMsTUFBTSxPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUU7O3NCQUVwQyxRQUFRLENBQUMsU0FBUyxDQUFDLElBQUk7WUFDakMsU0FBUzs7SUFFakIsV0FBVzs7Ozs7O2NBTUQsY0FBYzs7Q0FFM0IsQ0FBQyJ9